import { buildUrlWithQueryParams } from '../../utils/common/functions';
import { handleApi } from '../common';

const MY_ACCOUNT_API_CONSTANTS = {
	myAccount: '/api/iam/myaccount',
	addAdditionalBank: '/api/kyc/bank/add/additionalbank/mine',
	accountSummary: '/api/rta/mine/getaccountsummary',
	uploadMandate: '/api/mandate/blank/signed/upload',
	emailStatements: (props) =>
		`/api/invest/${props.statement}?year=${props.year}`,
	whatsappSubcribe: '/api/communication/contact/subscription',
	referralCode: (code) => `api/referral/apply?code=${code}`,
	mandateNps: '/api/nps/invest/mandate/requestmandate',
	getEquityAccountPreferences:
		'/api/equity/api/eqm/my/account/get/preference',
	updateEquityAccountPreferences:
		'/api/equity/api/eqm/my/account/update/preference',
	updateEmailSubscriptions: '/api/communication/unsubscription/user',
	getEmailSubscriptions: '/api/communication/unsubscription/get/status',
	triggerAOFFormEmail: '/api/kyc/equity/aof/send',
	triggerCMLFormEmail: '/api/equity/api/eqm/cml/send/cml/email',
	getCMLStatusForUser: (user_id) =>
		buildUrlWithQueryParams('/api/equity/api/eqm/cml/details', { user_id }),
	getEquityBalance: `/api/equity/api/eqm/wave/get/balance`,
	emailMfTransactions: '/api/rta/mine/getaccountsummary',
	emailPortfolioStatement: (year) =>
		`/api/reports/yearly_portfolio?year=${year}`,
	triggerMfStatement: (statementType, year) =>
		`/api/invest/${statementType}?year=${year}`,
	triggerEquityStatement: (statementType) =>
		`/api/equity/get/broking/reports/${statementType}_statement`,
	getServiceRedirectionUrl:
		'/api/iam/redirect_url/tp/authenticated/users/aegis',
};

export const fetchBalanceDetail = async (Api) => {
	const res = await Api.get(MY_ACCOUNT_API_CONSTANTS.getEquityBalance);
	const balance = handleApi(res);
	return balance;
};

export const fetchMyAccountDetails = async (Api, token) => {
	const res = await Api.get(
		MY_ACCOUNT_API_CONSTANTS.myAccount,
		{},
		{},
		token,
	);
	const accountDetails = handleApi(res);
	return accountDetails;
};

export const fetchAdditionalBank = async (Api, bodyData) => {
	const res = await Api.post(
		MY_ACCOUNT_API_CONSTANTS.addAdditionalBank,
		bodyData,
	);
	const result = handleApi(res);
	return result;
};

export const getaccountsummary = async (Api, bodyData) => {
	const res = await Api.get(MY_ACCOUNT_API_CONSTANTS.accountSummary);
	const result = handleApi(res);
	return result;
};

export const updateMandate = async (Api, payload) => {
	const res = await Api.post(MY_ACCOUNT_API_CONSTANTS.uploadMandate, payload);
	const result = handleApi(res);
	return result;
};

export const emailStatements = async (Api, payload) => {
	const res = await Api.get(
		MY_ACCOUNT_API_CONSTANTS.emailStatements(payload),
	);
	const result = handleApi(res);
	return result;
};

export const subscribeWhatsapp = async (Api, payload) => {
	const res = await Api.post(
		MY_ACCOUNT_API_CONSTANTS.whatsappSubcribe,
		payload,
	);
	const result = handleApi(res);
	return result;
};

export const applyPartnerCode = async (Api, code) => {
	const res = await Api.get(MY_ACCOUNT_API_CONSTANTS.referralCode(code));
	const result = handleApi(res);
	return result;
};

export const authenticateNpsMandate = async (Api, payload) => {
	const res = await Api.post(MY_ACCOUNT_API_CONSTANTS.mandateNps, payload);
	const result = handleApi(res);
	return result;
};

export const updateEquityAccPreferences = async (
	Api,
	urlParams = {},
	payload,
) => {
	const res = await Api.post(
		buildUrlWithQueryParams(
			MY_ACCOUNT_API_CONSTANTS.updateEquityAccountPreferences,
			urlParams,
		),
		payload,
	);
	const result = handleApi(res);
	return result;
};

export const getEquityAccPreferences = async (Api, payload) => {
	const res = await Api.get(
		MY_ACCOUNT_API_CONSTANTS.getEquityAccountPreferences,
		payload,
	);
	const result = handleApi(res);
	return result;
};

export const getEmailSubscription = async (Api, payload) => {
	const res = await Api.post(
		MY_ACCOUNT_API_CONSTANTS.getEmailSubscriptions,
		payload,
	);
	return handleApi(res);
};

export const updateEmailSubscription = async (Api, payload) => {
	const res = await Api.post(
		MY_ACCOUNT_API_CONSTANTS.updateEmailSubscriptions,
		{
			communication_type: 'email',
			requested_by: 'user',
			...payload,
		},
	);
	return handleApi(res);
};

export const getCMLStatusForUser = async (Api, userId, payload) => {
	const res = await Api.get(
		MY_ACCOUNT_API_CONSTANTS.getCMLStatusForUser(userId),
		payload,
	);
	return handleApi(res);
};

export const triggerCMLFormEmail = async (Api, payload) => {
	const res = await Api.get(
		MY_ACCOUNT_API_CONSTANTS.triggerCMLFormEmail,
		payload,
	);
	return handleApi(res);
};

export const triggerAOFFormEmail = async (Api, payload) => {
	const res = await Api.get(
		MY_ACCOUNT_API_CONSTANTS.triggerAOFFormEmail,
		payload,
	);
	return handleApi(res);
};

export const triggerEquityStatement = async (Api, payload) => {
	const { statementType, ...restPayload } = payload;
	const res = await Api.post(
		MY_ACCOUNT_API_CONSTANTS.triggerEquityStatement(statementType),
		restPayload,
	);
	return handleApi(res);
};

export const triggerMfStatement = async (Api, payload) => {
	const { statementType, year, ...restPayload } = payload;
	const res = await Api.get(
		MY_ACCOUNT_API_CONSTANTS.triggerMfStatement(statementType, year),
		restPayload,
	);
	return handleApi(res);
};

export const emailPortfolioStatement = async (Api, year) => {
	const res = await Api.get(
		MY_ACCOUNT_API_CONSTANTS.emailPortfolioStatement(year),
	);
	const result = handleApi(res);
	return result;
};

export const emailMfTransactions = async (Api) => {
	const res = await Api.get(MY_ACCOUNT_API_CONSTANTS.emailMfTransactions);
	const result = handleApi(res);
	return result;
};

export const getServiceRedirectionUrl = async (Api, payload) => {
	const res = await Api.post(
		MY_ACCOUNT_API_CONSTANTS.getServiceRedirectionUrl,
		payload,
	);
	const result = handleApi(res);
	return result;
};
